// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Date Picker Styles */
.custom-date-picker-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 0;
}

/* Calendar container */
.react-calendar {
    width: 100%;
    max-width: 400px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Navigation */
.react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 10px;
    background-color: #f8f9fa;
    border-radius: 8px 8px 0 0;
}

.react-calendar__navigation button {
    min-width: 44px;
    background: none;
    border: none;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
    background-color: #e9ecef;
    color: #28a745;
}

.react-calendar__navigation button:disabled {
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
}

/* Month view */
.react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.85em;
    color: #666;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
}

.react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
}

.react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
}

/* Tiles (date cells) */
.react-calendar__tile {
    max-width: 100%;
    padding: 12px 6px;
    background: none;
    text-align: center;
    line-height: 20px;
    border: none;
    cursor: pointer;
    font-size: 0.95em;
    border-radius: 6px;
    transition: all 0.2s ease;
    margin: 2px;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
    background-color: #e6f7e6;
    color: #28a745;
}

/* Today's date */
.react-calendar__tile--now {
    background: #1ee576a3;
    font-weight: bold;
}

.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
    background: #1ee576a3;
}

/* Selected date */
.react-calendar__tile--active {
    background: #28a745 !important;
    color: white !important;
    font-weight: bold;
}

.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
    background: #218838 !important;
}

/* Highlighted dates (existing holidays) */
.highlighted-date {
   background-color: #046a38  !important;
    color: #ffffff !important;
    font-weight: bold;
    position: relative;
}

.highlighted-date::after {
    content: '●';
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    color: #d63031;
    font-size: 8px;
}

.highlighted-date:enabled:hover {
    background-color: #1ee576a3  !important;
/* Disabled dates (past dates) */
}
.disabled-date {
    background-color: #f5f5f5;
    color: #ccc !important;
    cursor: not-allowed;
}

/* Weekend styling (optional) */
.react-calendar__month-view__days__day--weekend {
    color: #d63031;
}

/* Neighboring month dates */
.react-calendar__month-view__days__day--neighboringMonth {
    color: #bbb;
}

/* Month/Year view */
.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
    padding: 1.5em 0.5em;
}

/* Responsive design */
@media (max-width: 576px) {
    .react-calendar {
        max-width: 100%;
    }
    
    .react-calendar__tile {
        padding: 10px 4px;
        font-size: 0.9em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/holidaysList/customDatePicker.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,0CAA0C;AAC1C;GACG,qCAAqC;IACpC,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C,gCAAgC;AAChC;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;AACf;;AAEA,oBAAoB;AACpB;;;IAGI,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":["/* Custom Date Picker Styles */\n.custom-date-picker-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 10px 0;\n}\n\n/* Calendar container */\n.react-calendar {\n    width: 100%;\n    max-width: 400px;\n    background: white;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-family: Arial, Helvetica, sans-serif;\n    line-height: 1.5;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Navigation */\n.react-calendar__navigation {\n    display: flex;\n    height: 44px;\n    margin-bottom: 10px;\n    background-color: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n}\n\n.react-calendar__navigation button {\n    min-width: 44px;\n    background: none;\n    border: none;\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n    background-color: #e9ecef;\n    color: #28a745;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: transparent;\n    color: #ccc;\n    cursor: not-allowed;\n}\n\n/* Month view */\n.react-calendar__month-view__weekdays {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.85em;\n    color: #666;\n    padding: 10px 0;\n    border-bottom: 1px solid #eee;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    padding: 0.5em;\n}\n\n.react-calendar__month-view__weekdays__weekday abbr {\n    text-decoration: none;\n}\n\n/* Tiles (date cells) */\n.react-calendar__tile {\n    max-width: 100%;\n    padding: 12px 6px;\n    background: none;\n    text-align: center;\n    line-height: 20px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.95em;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    margin: 2px;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n    background-color: #e6f7e6;\n    color: #28a745;\n}\n\n/* Today's date */\n.react-calendar__tile--now {\n    background: #1ee576a3;\n    font-weight: bold;\n}\n\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n    background: #1ee576a3;\n}\n\n/* Selected date */\n.react-calendar__tile--active {\n    background: #28a745 !important;\n    color: white !important;\n    font-weight: bold;\n}\n\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n    background: #218838 !important;\n}\n\n/* Highlighted dates (existing holidays) */\n.highlighted-date {\n   background-color: #046a38  !important;\n    color: #ffffff !important;\n    font-weight: bold;\n    position: relative;\n}\n\n.highlighted-date::after {\n    content: '●';\n    position: absolute;\n    bottom: 2px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: #d63031;\n    font-size: 8px;\n}\n\n.highlighted-date:enabled:hover {\n    background-color: #1ee576a3  !important;\n/* Disabled dates (past dates) */\n}\n.disabled-date {\n    background-color: #f5f5f5;\n    color: #ccc !important;\n    cursor: not-allowed;\n}\n\n/* Weekend styling (optional) */\n.react-calendar__month-view__days__day--weekend {\n    color: #d63031;\n}\n\n/* Neighboring month dates */\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #bbb;\n}\n\n/* Month/Year view */\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n    padding: 1.5em 0.5em;\n}\n\n/* Responsive design */\n@media (max-width: 576px) {\n    .react-calendar {\n        max-width: 100%;\n    }\n    \n    .react-calendar__tile {\n        padding: 10px 4px;\n        font-size: 0.9em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
